// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2Oqj2","row":"styles_row__1YpQI"};